import { put, takeEvery } from 'redux-saga/effects';

import * as TYPES from "../types";

import { GET_ALL_ANNOUNCEMENTS_LIST, GET_ALL_BANNERS_LIST, GET_ALL_COLLABORATION_LIST, GET_ALL_EVENTS_LIST, GET_ALL_KR_LIST, GET_ALL_ONGOING_PROJECT_LIST, GET_ALL_RESEARCH_LIST, GET_ALL_TEAM_MEMBERS_LIST, GET_ALL_VACANCIES_LIST, GET_UPCOMING_PROJECT_LIST } from "./Services";
import { getAllKnowledgeRepositorySuccessAction } from '../Actions/KnowledgeRepositoryActions';
import { loadingEndAction, loadingStartAction } from '../Actions/LoadingAction';
import { getAllCollaborationSuccessAction } from '../Actions/CollaborationActions';
import { getAllResearchSuccessAction } from '../Actions/ResearchAction';
import { getAllOnGoingProjectSuccessAction, getAllUpcomingProjectSuccessAction } from '../Actions/ProjectActions';
import { getAllTeamSuccessAction } from '../Actions/TeamAction';
import { getAllEventSuccessAction } from '../Actions/EventActions';
import { getAllAnnouncementSuccessAction } from '../Actions/AnnouncementActions';
import { getAllVacanciesSuccessAction } from '../Actions/VacanciesActions';
import { getAllBannerSuccessAction } from '../Actions/BannerActions';

function* getAllKRList() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_KR_LIST();
        if (!response) {
            console.error("Get All K_Repo Response Error")
        } else {
            yield put(getAllKnowledgeRepositorySuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All K_Repo Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllCollaboration() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_COLLABORATION_LIST();
        if (!response) {
            console.error("Get All Collaboration Response Error")
        } else {
            yield put(getAllCollaborationSuccessAction(response?.collaborations));
        }
    } catch (error) {
        console.error("Get All Collaboration Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllResearch() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_RESEARCH_LIST();
        if (!response) {
            console.error("Get All Research Response Error")
        } else {
            yield put(getAllResearchSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All Research Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllOngoingProject() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_ONGOING_PROJECT_LIST();
        if (!response) {
            console.error("Get All ongoing project Error")
        } else {
            yield put(getAllOnGoingProjectSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All ongoing Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllUpcomingProject() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_UPCOMING_PROJECT_LIST();
        if (!response) {
            console.error("Get All upcoming project Error")
        } else {
            yield put(getAllUpcomingProjectSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All upcoming Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllTeamMembers(data) {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_TEAM_MEMBERS_LIST(data?.payload);
        if (!response) {
            console.error("Get All Team Member Error")
        } else {
            yield put(getAllTeamSuccessAction(response?.posts?.reverse()));
        }
    } catch (error) {
        console.error("Get All Team Member Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllEvents() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_EVENTS_LIST();
        if (!response) {
            console.error("Get All Events Error")
        } else {
            yield put(getAllEventSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All Events Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllAnnouncement() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_ANNOUNCEMENTS_LIST();
        if (!response) {
            console.error("Get All Events Error")
        } else {
            const sortedData = response?.posts?.sort((a, b) => b.id - a.id);
            yield put(getAllAnnouncementSuccessAction(sortedData));
        }
    } catch (error) {
        console.error("Get All Events Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllVacancies() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_VACANCIES_LIST();
        if (!response) {
            console.error("Get All Events Error")
        } else {
            yield put(getAllVacanciesSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All Events Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* getAllBanners() {
    try {
        yield put(loadingStartAction());
        const response = yield GET_ALL_BANNERS_LIST();
        if (!response) {
            console.error("Get All Events Error")
        } else {
            yield put(getAllBannerSuccessAction(response?.posts));
        }
    } catch (error) {
        console.error("Get All Events Error")
    } finally {
        yield put(loadingEndAction());
    }
}

function* SagaData() {

    yield takeEvery(TYPES.GET_ALL_K_REPO, getAllKRList);
    yield takeEvery(TYPES.GET_ALL_COLLABORATION, getAllCollaboration);
    yield takeEvery(TYPES.GET_ALL_RESEARCH, getAllResearch);

    yield takeEvery(TYPES.GET_ALL_ONGOING_PROJECT, getAllOngoingProject);
    yield takeEvery(TYPES.GET_ALL_UPCOMING_PROJECT, getAllUpcomingProject);

    yield takeEvery(TYPES.GET_ALL_TEAM_MEMBERS, getAllTeamMembers);

    yield takeEvery(TYPES.GET_ALL_EVENTS, getAllEvents);

    yield takeEvery(TYPES.GET_ALL_ANNOUNCEMENTS, getAllAnnouncement);

    yield takeEvery(TYPES.GET_ALL_VACANCIES, getAllVacancies);

    yield takeEvery(TYPES.GET_ALL_BANNERS, getAllBanners);

}

export default SagaData;